import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { Zones } from '../models/zones';

type SliceModel = Zones;
const sliceName: string = 'zones';

const currRequests: Set<ModelId> = new Set;

export const fetchZone = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const zoneAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id
});
export const zoneSlice = createSlice({
    name: sliceName,
    initialState: zoneAdapter.getInitialState(),
    reducers: {
        addMany: zoneAdapter.addMany,
        addOne: zoneAdapter.addOne,
        updateMany: zoneAdapter.updateMany,
        updateOne: zoneAdapter.updateOne,
        upsertOne: zoneAdapter.upsertOne,
        upsertMany: zoneAdapter.upsertMany,
        removeOne: zoneAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchZone.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                zoneAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
